import { writable } from 'svelte/store';
import type { Question } from '../../shared/types.ts';

export interface Speech {
  text: string;
  who: string;
  x: number;
  y: number;
}

export interface QuizSession {
  puzzle: string;
  title: string;
  need: number;
  questions: Question[];
  mode: 'lock' | 'single';
  resolve: (solved: boolean) => void;
}

export interface DialogView {
  name: string;
  who: string;
  text: string;
  choices: { id: string; label: string }[] | null;
  echo: boolean;
}

export interface ItemView {
  id: string;
  name: string;
  icon: string;
}

export interface UiState {
  screen: 'menu' | 'loading' | 'game';
  hover: { name: string; x: number; y: number } | null;
  speech: Speech | null;
  quiz: QuizSession | null;
  dialog: DialogView | null;
  inventory: ItemView[];
  quests: { id: string; text: string; done: boolean; side?: boolean }[];
  selected: string | null;
  busy: boolean;
  ended: string | null;
  show: boolean;
  shop: boolean;
  /** offenes Gespräch mit einem Stammgast (S9) */
  guest: string | null;
  /** ein Vollbild-Fenster verdeckt die Szene (Darstellung pausiert) */
  cover: boolean;
  /** Stadtkarte offen (S10) */
  map: boolean;
  /** Tageszeit 0–3 (null = Kapitel ohne Tageszeiten) */
  time: number | null;
  logbook: boolean;
  training: boolean;
  portrait: boolean;
  viewRect: { x: number; y: number; w: number; h: number };
  sceneName: string;
}

export const ui = writable<UiState>({
  screen: 'menu',
  hover: null,
  speech: null,
  quiz: null,
  dialog: null,
  inventory: [],
  quests: [],
  selected: null,
  busy: false,
  ended: null,
  show: false,
  shop: false,
  guest: null,
  cover: false,
  map: false,
  time: null,
  logbook: false,
  training: false,
  portrait: false,
  viewRect: { x: 0, y: 0, w: 0, h: 0 },
  sceneName: '',
});

export function patch(p: Partial<UiState>) {
  ui.update((s) => ({ ...s, ...p }));
}
